import styled, { keyframes } from 'styled-components/macro';

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background: #0d0d0d;
  overflow: hidden;
`;

export const VideoSection = styled.div`
  flex: ${(props) => (props.showProducts ? '0 0 65%' : '1')};
  transition: all 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  cursor: ${({ showControls }) => (showControls ? 'default' : 'none')};
`;

export const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 70%, transparent 100%);
  padding: 50px 20px 15px;
  transition: all 0.3s ease;
  opacity: ${({ show }) => (show ? '1' : '0')};
  pointer-events: ${({ show }) => (show ? 'all' : 'none')};
  z-index: 5;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 5px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  cursor: pointer;
  margin-bottom: 15px;
  position: relative;
  transition: height 0.2s ease;

  &:hover {
    height: 8px;
  }
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: #15d71b;
  border-radius: 2px;
  width: ${({ progress }) => progress}%;
  position: relative;
  transition: width 0.1s linear;
  z-index: 3;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: #15d71b;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(21, 215, 27, 0.5);
  }
`;

export const BufferedBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
  width: ${({ buffered }) => buffered}%;
  z-index: 2;
`;

export const ControlsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const ControlsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const ControlsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const TimeDisplay = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin-left: 10px;
  white-space: nowrap;
`;

export const VolumeControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const VolumeSlider = styled.input`
  width: 80px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.3);
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    border: none;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;

  .spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-top-color: #15d71b;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  z-index: 8;
  pointer-events: none;
  animation: fadeOut 0.5s ease-out;

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const PlayPauseIcon = styled.div`
  font-size: 80px;
  color: white;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  animation: scaleUp 0.3s ease-out;

  @keyframes scaleUp {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const ProductBadge = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, rgba(21, 215, 27, 0.95) 0%, rgba(14, 163, 86, 0.95) 100%);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(21, 215, 27, 0.4);
  transition: all 0.3s ease;
  animation: slideInLeft 0.5s ease-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(21, 215, 27, 0.6);
    background: linear-gradient(135deg, rgba(21, 215, 27, 1) 0%, rgba(14, 163, 86, 1) 100%);
  }

  &:active {
    transform: translateY(0);
  }

  @keyframes slideInLeft {
    from {
      transform: translateX(-100px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const ProductsSection = styled.div`
  flex: 0 0 35%;
  background: linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%);
  padding: 20px;
  overflow-y: auto;
  height: 100vh;
  border-left: 1px solid rgba(255, 255, 255, 0.1);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(21, 215, 27, 0.5);
    border-radius: 4px;

    &:hover {
      background: rgba(21, 215, 27, 0.7);
    }
  }
`;

export const ProductsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 15px;
`;

export const ProductsTitle = styled.h2`
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
`;

export const ProductsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ProductCard = styled.div`
  display: flex;
  gap: 12px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, rgba(21, 215, 27, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
    border-color: rgba(21, 215, 27, 0.5);
    box-shadow: 0 4px 15px rgba(21, 215, 27, 0.2);
  }
`;

export const ProductImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
`;

export const ProductTitle = styled.h4`
  color: white;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const ProductPrice = styled.div`
  color: #15d71b;
  font-size: 14px;
  font-weight: 700;
`;

export const ProductLink = styled.a`
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #15d71b 0%, #0ea356 100%);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  width: fit-content;
  transition: all 0.3s ease;
  margin-top: 6px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(21, 215, 27, 0.4);
    background: linear-gradient(135deg, #0ea356 0%, #15d71b 100%);
  }
`;

export const QRColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QRImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background: white;
  padding: 2px;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  border: 3px solid rgba(21, 215, 27, 0.2);
  border-top: 3px solid #15d71b;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

export const EmptyMessage = styled.div`
  color: #999;
  text-align: center;
  padding: 40px 20px;
  font-size: 14px;
`;
